import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalState } from '../../../store';
import { signoutUser } from '../../../utils/auth';

const LogoutPage = () => {
  const navigate = useNavigate();
  const [, setUser] = useGlobalState('user');

  useEffect(() => {
    // Clear user from global state
    setUser({});
    
    // Call the signout function with the navigate function
    signoutUser(navigate);
  }, []);

  // This component doesn't render anything as it immediately redirects
  return null;
};

export default LogoutPage;
